import { Injectable } from '@angular/core';
import { gql, Mutation} from 'apollo-angular';
import { RefreshTokenResponse } from '../components/login/login.model';

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenService extends Mutation<RefreshTokenResponse> {
  document = gql`
    mutation RefreshToken {
      refreshToken {
        access_token
      }
    }
  `;
}
